import React, { FC, ReactNode } from 'react';
import classNames from 'classnames';

import styles from '#components/common/teaser-meta/TeaserTitle.module.scss';

type Props = {
  children: ReactNode;
  size?: 'small' | 'medium' | 'large';
  element?: 'h4' | 'h3' | 'p';
  lines?: 1 | 2 | 3;
  bottomGutter?: boolean;
};

const TeaserTitle: FC<Props> = ({
  size = 'medium',
  element = 'h3',
  lines = 2,
  children,
  bottomGutter = true,
}) => {
  const className = classNames(styles.teaserTitle, styles[size], {
    [styles.bottomGutter]: bottomGutter === true,
  });

  return React.createElement(
    element,
    {
      className: `${className} tw-line-clamp-${lines}`,
    },
    children
  );
};

export default TeaserTitle;
